import { SerializedStyles } from "@emotion/react";
import { Ref, memo } from "react";

import { types } from "@fraction/shared";

import SocialXNumberCA from "./regions/SocialXNumberCA";
import SocialXNumberUS from "./regions/SocialXNumberUS";

export interface SocialXNumberProps {
  location?: types.ExtractedPropertyAddress;
  value?: string;
  onChange: (value: string) => void;
  title?: string;

  focusRef?: Ref<HTMLInputElement>;
  onNext: () => void;
  onBack: () => void;
  style?: SerializedStyles;
}

const SocialXNumber = ({ location, ...props }: SocialXNumberProps) => {
  if (location?.country === "CA") {
    return <SocialXNumberCA {...props} />;
  }
  return <SocialXNumberUS {...props} />;
};

export default memo(SocialXNumber);
